module.exports = __webpack_public_path__ + "media/carcinoid tumor.c96f6030.wav";